import rp, { helpers } from "@reporting/rp-app-host";
import { TreeAdapter, TreeOptions, TreeSource } from "@omegagrid/tree";
import { Project } from "@reporting/rp-types/ext";
import { msg } from "@omegagrid/localize";

/** Project of another company, shared with this one or inherited from a parent company */
export const isForeignProject = (project: Project) => project?.accounting != null && project.accounting !== rp.accountingProvider.a;

export const projectCaption = (project: Project, name = project.name) =>
	`#${project.id_custom_page} ${name}` + (isForeignProject(project) ? ` (#${project.accounting})` : '');

export class ProjectTreeAdapter extends TreeAdapter {

	constructor(private options?: {newProject?: boolean, search?: boolean}) {
		super();
	}

	async getTree(): Promise<TreeSource> {
		const items: TreeSource = [];
		const projects = await rp.ms('extensions').get<Project[]>(`projects`, {
			fields: ['id_custom_page', 'accounting', 'name', 'version'],
			order: [['name', 'asc']],
			includeShared: true
		});

		if (this.options?.newProject) {
			items.push({k: '0', v: `<${msg('New project')}>`, l: 0, icon: 'plus'});
		}

		projects.sort((a, b) => helpers.comparePaths(a.name, b.name));

		let parents: string[] = [];
		projects.forEach(project => {
			const chunks = project.name.split('/');
			const projectName = chunks.pop();

			for (let i = helpers.commonPathLength(chunks, parents); i < chunks.length; i++) {
				const dir = chunks[i];

				items.push({
					k: dir,
					v: dir,
					l: i,
					ch: false,
					collapsed: false,
				});
			}

			items.push({
				k: project.id_custom_page.toString(),
				v: projectCaption(project, projectName),
				l: chunks.length,
				icon: isForeignProject(project) ? 'share-nodes' : undefined,
				props: { project }
			});

			parents = chunks;
		});

		return items;
	}

	getOptions(): TreeOptions {
		return {
			globalLevels: false,
			selectMode: 'single',
			checkboxes: false,
			search: this.options?.search !== false,
			autoClose: true,
			expanders: false,
			folderOptions: {
				openIcon: 'folder-open',
				closedIcon: 'folder',
			}
		};
	}

}
